/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Page_Title_Report_IssueInputs */

const en_page_title_report_issue = /** @type {(inputs: Page_Title_Report_IssueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Report an issue`)
};

const nl_page_title_report_issue = /** @type {(inputs: Page_Title_Report_IssueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Probleem melden`)
};

/**
* | output |
* | --- |
* | "Report an issue" |
*
* @param {Page_Title_Report_IssueInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const page_title_report_issue = /** @type {((inputs?: Page_Title_Report_IssueInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_Title_Report_IssueInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_page_title_report_issue(inputs)
	return en_page_title_report_issue(inputs)
});